// This file should contain ALL keys used by *any* environment
// the values in this file should be that of the DEVELOPMENT environment
// other named environment files (i.e. environment.smoke.ts) should include ONLY overrides to values as necessary
// Common configs point to nightly environment

export const commonConfig = {
  appId: 'savvaslearning',
  appName: 'savvaslearning',
  authContextId: '6065',
  metricMeasureCompany: 'MetaMetrics, Inc.',
  production: false,
  authGatewayUrl: 'https://rr-auth-gateway.nightly.savvasrealizedev.com/sapi',
  realizeUrl: 'https://nightly-www.savvasrealizedev.com',
  rbsConfig: {
    scope: 'rbs',
    clientId: '',
    grant_type: 'custom_castgc',
  },
  ssoUrl: 'https://nightly-sso.rumba.pk12ls.com/sso',
  ssoLoginQueryParams: {
    k12int: true,
  },
  errorRoute: 'error',
  authCallbackRoute: 'multi-stage-growth-report-webapp/auth-callback',
  backendForFrontend: {
    url: 'https://dev.multi-stage-growth-report-bff.savvasrealizedev.com',
    apiPath: '/graphql',
  },
  multiStageReportConfig: {
    remoteEntry:
      'https://nightly-www.savvasrealizedev.com/multi-stage-report-mastery-web/multiStageReportRemoteEntry.js',
    remoteName: 'multiStageReportWebapp',
    exposedModule: './MultiStageReportLoaderModule',
    moduleName: 'MultiStageReportLoaderModule',
  },
  searchViewerConfig: {
    remoteEntry: 'https://nightly-www.savvasrealizedev.com/search/viewer/rswRemoteEntry.js',
    remoteName: 'resourceSearchWeb',
    exposedModule: './view-resources',
    moduleName: 'ViewResourcesModule',
  },
  resourceSearchConfig: {
    remoteEntry: 'https://nightly-www.savvasrealizedev.com/search/viewer/rswRemoteEntry.js',
    remoteName: 'resourceSearchWeb',
    exposedModule: './rsw-search',
    moduleName: 'RswRootModule',
  },
  envName: 'Nightly',
};
